export enum SeturLoyaltyPointsHistoryFiltersDateTypes {
  LAST3MONTHS = 'Last3Months',
  LAST6MONTHS = 'Last6Months',
  LAST12MONTHS = 'Last12Months',
}
